import { ArrowLeft } from "lucide-react";
import { LOGO_URL, TERMS_SECTIONS, CONTACT } from "@/content";
import { Reveal } from "@/components/landing/Reveal";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-black text-white antialiased">
      <div className="grain-overlay" aria-hidden="true" />

      <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-6">
          <a href="/" data-testid="terms-logo-link" className="flex items-center">
            <img
              src={LOGO_URL}
              alt="Desires After Hours flame logo"
              className="h-9 w-9 rounded-full object-cover ring-1 ring-white/20"
            />
          </a>
          <a
            href="/"
            data-testid="terms-back-link"
            className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-white"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 pb-24 pt-32 sm:pt-40">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-zinc-400">
            Desires After Hours
          </p>
          <h1
            data-testid="terms-heading"
            className="mt-4 font-display text-3xl font-extrabold uppercase tracking-tight sm:text-5xl"
          >
            Terms & <span className="text-zinc-500">Policies</span>
          </h1>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-zinc-400 sm:text-base">
            The policies below apply to every service we provide. By purchasing
            or receiving any service from Desires After Hours, you agree to them
            in full.
          </p>
        </Reveal>

        <div className="mt-16 divide-y divide-white/5 border-y border-white/10">
          {TERMS_SECTIONS.map((section, i) => (
            <Reveal key={section.id} delay={i * 0.06}>
              <section data-testid={`terms-section-${section.id}`} className="py-8">
                <h2 className="font-display text-lg font-bold tracking-tight sm:text-xl">
                  <span className="mr-4 font-mono text-xs tracking-[0.3em] text-zinc-500">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {section.title}
                </h2>
                <p className="mt-4 max-w-2xl text-sm leading-relaxed text-zinc-400 sm:text-base">
                  {section.text}
                </p>
              </section>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-12 text-sm text-zinc-500">
            Questions about these terms? Email us at{" "}
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="terms-email-link"
              className="text-white underline decoration-white/30 underline-offset-4 transition-colors duration-300 hover:decoration-white"
            >
              {CONTACT.email}
            </a>
            .
          </p>
        </Reveal>
      </main>
    </div>
  );
}
